import { Chip } from '@/global/components/Chip'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import dayjs from 'dayjs'
import { OpcoesCompensacaoManualButton } from './opcoes'

export const columns: GridColDefPro[] = [
    {
        field: 'funcionarioId',
        headerName: 'Funcionário',
        minWidth: 200,
        flex: 1,
        valueGetter: ({ row }) =>
            row.Funcionario?.nome || `ID: ${row.funcionarioId}`,
    },
    {
        field: 'tipo',
        headerName: 'Tipo',
        width: 150,
        renderCell: ({ value }) => (
            <Chip
                label={value === 'COMPENSAR' ? 'Compensar' : 'Compensado'}
                color={value === 'COMPENSAR' ? 'info' : 'success'}
            />
        ),
    },
    {
        field: 'data',
        headerName: 'Data',
        width: 130,
        type: 'date',
        valueFormatter: ({ value }) => {
            return dayjs(value as Date).format('DD/MM/YYYY')
        },
    },
    {
        field: 'competencia',
        headerName: 'Competência',
        width: 120,
        valueFormatter: ({ value }) => {
            return dayjs(value as string, 'YYYY-MM').format('MM/YYYY')
        },
    },
    {
        field: 'Destinos',
        headerName: 'Destinos',
        width: 100,
        align: 'center',
        valueGetter: ({ value }) => {
            if (!value || value.length === 0) return 0
            return value.length
        },
        renderCell: ({ value }) => {
            if (value === 0) return <span className="text-gray-400">-</span>
            return <Chip label={`${value} dia(s)`} />
        },
    },
    {
        field: 'calculoId',
        headerName: 'Vinculado',
        width: 100,
        align: 'center',
        valueGetter: ({ value }) => (value ? 'Sim' : 'Não'),
        renderCell: ({ value }) => (
            <Chip
                label={value}
                color={value === 'Sim' ? 'success' : undefined}
            />
        ),
    },
    {
        field: 'createdAt',
        headerName: 'Criado em',
        width: 160,
        valueFormatter: ({ value }) => {
            return dayjs(value as Date).format('DD/MM/YYYY HH:mm')
        },
    },
    {
        field: 'opcoes',
        headerName: '',
        align: 'center',
        width: 90,
        sortable: false,
        filterable: false,
        renderCell: OpcoesCompensacaoManualButton,
    },
]

export default columns
